import React, { useState, useRef, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import withdrawCardIcon from '../../../../assets/img/icon/credit-gif.gif';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { FaAngleLeft, FaChevronDown } from 'react-icons/fa6'
import { FaUserFriends, FaUniversity, FaMobileAlt } from 'react-icons/fa';
import { RiUserReceivedLine } from "react-icons/ri";
import { toast } from 'react-toastify';
import ReactFlagsSelect from 'react-flags-select';
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

import CardsProgressSteps from '../../../../components/ProgressStep/CardsProgressSteps'

import '../SendMoney/sendMoney.css';
import { fetchSupportedCountryBanks } from '../../../../actions';
import { fetchRecipientDetails, fetchWallets } from '../../../../actions/payments';
import { getAuthenticatedUser } from '../../../../actions/auth';

const sendOptions = [
  // {
  //   id: 'cardplot',
  //   title: 'Cardplot Account',
  //   description: 'Send money directly to another Cardplot user instantly.',
  //   icon: <FaUserFriends size={16} className="text-primary" />
  // },
  {
    id: 'bank',
    title: 'Bank Account',
    description: 'Send money to any local or international bank account.',
    icon: <FaUniversity size={16} className="text-success" />
  },
  {
    id: 'mobile',
    title: 'Mobile Money Transfer',
    description: 'Send funds to a mobile money wallet (Momo, MTN, Orange).',
    icon: <FaMobileAlt size={16} className="text-warning" />
  },
];

const fundingOptions = [
  { id: 1, slug: "verve", name: "NGN Verve Card", currencyCode: "NGN", countryCode: "NG" },
  { id: 2, slug: "mastercard", name: "USD Mastercard", currencyCode: "USD", countryCode: "US" },
  { id: 3, slug: "visa", name: "USD VISA Card", currencyCode: "USD", countryCode: "US" },
];

const mobileMoneyOperators = [
  { id: 1, name: "MTN Mobile Money (Ghana)", slug: "mtn-momo-gh" },
  { id: 2, name: "M-Pesa (Kenya)", slug: "mpesa-ke" },
  { id: 3, name: "Orange Money (Ivory Coast)", slug: "orange-money-ci" },
  { id: 4, name: "Airtel Money (Uganda)", slug: "airtel-money-ug" },
  { id: 5, name: "Glo Mobile Money (Nigeria)", slug: "glo-money-ng" },
];

// Register the locale
countries.registerLocale(enLocale);

// Generate a mapping of country codes to their full names
const countryNames = countries.getNames("en", { select: "official" });

const Step1WithdrawMoney = ({ userDetails }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedTransferLocation = location.state?.selectedTransferLocation;
  const [selectedOption, setSelectedOption] = useState(null)
  const [showDropdown, setShowDropdown] = useState(false)
  const dropdownRef = useRef(null);
  const isLocalTransfer = true;
  const defaultCountry = userDetails?.country_code.toLowerCase() || "ng";  
  const excludeCountryCode = defaultCountry?.toUpperCase();
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const { allowedCountries, currencyOptions } = useSelector((state) => state.country);
  const allowedCountryCodes = allowedCountries.map((code) => code.toUpperCase());
  const [userWallets, setUserWallets] = useState([]);
  const [currenciesOption, setCurrenciesOption] = useState([]);
  const filteredCountryCodes = allowedCountryCodes.filter(code => code !== excludeCountryCode);
  const [fundingSource, setFundingSource] = useState('');
  const [recipientUsername, setRecipientUsername] = useState('');
  const [userRecipientInput, setUserRecipientInput] = useState('');
  const [inputtedAccountName, setInputtedAccountName] = useState('');
  const [accountName, setAccountName] = useState('');
  const [bankName, setBankName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [mobileMoney, setMobileMoney] = useState('');
  const [phone, setPhone] = useState('');
  const [transactionDescription, setTransactionDescription] = useState('');
  const [isEdited, setIsEdited] = useState(false);
  const [loadingBanks, setLoadingBanks] = useState(false);
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const recipientCache = useRef({});  
  const dispatch = useDispatch(); 
  const [amount, setAmount] = useState("");
  // console.log(userWallets);
  
  

  const getRecipientCredentials = async (recipientInput) => {
    if (recipientCache.current[recipientInput]) {
      setRecipientUsername(recipientCache.current[recipientInput]);
      return { success: true, data: recipientCache.current[recipientInput] };
    }

    setLoading(true);
    try {
      const response = await fetchRecipientDetails(recipientInput);

      if (response.status === 400) {
        toast.error(response.response.data.message, { toastId: "validation-toast3" });
        return { success: false };
      } else {
        const recipientName = response?.data;
        
        setRecipientUsername(recipientName);
        return { success: true, data: recipientName };
      }
      
    } catch (error) {
      console.error("Error fetching user:", error);
      toast.error('Recipient account not found', { toastId: "validation-toast3" });
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const fetchAllWallets = async () => {
      setLoading(true);
      try {
          const response = await fetchWallets();
          // const data = await getAuthenticatedUser(dispatch);
          
          const wallets = response.data.wallets;
          // const wallets = data.all_wallets;
          

          // Enrich wallet data with currencyOptions
          const enrichedWallets = wallets.map((wallet) => {
              const match = currencyOptions.find(opt => opt.currencyCode === wallet.currency);
              return {
                ...wallet,
                currencyName: match?.currencyName,
                currencyId: match?.id,
                currencySymbol: match?.symbol,
                flag: match?.flagUrl,
              };
          });

          setUserWallets(enrichedWallets);
      } catch (error) {
          // console.error("Error fetching wallets:", error);
      } finally {
          setLoading(false);
      }
  };
  useEffect(() => {
    if (currencyOptions.length > 0) {
        fetchAllWallets();
    }
  }, [currencyOptions]);

  const handleWalletSelectChange = (e) => {
    const selectedId = parseInt(e.target.value);
    const selectedOption = userWallets.find((opt) => opt.id === selectedId);
    
    setFundingSource(selectedOption);
    setIsEdited(true);
  };  
  
  

  const handleGoBack = () => {
    navigate("/user/send_money");
  }
  // console.log(userWallets);
  
  const handleAmountChange = (e) => {
      setAmount(e.target.value);
      setIsEdited(true);
  };

  const handleContinue = async (e) => {
    e.preventDefault();
  
    if (!selectedOption) {
      toast.error("Please select an option.", { toastId: "validation-toast1" });
      return;
    }

    if ((selectedOption?.id === 'bank' || selectedOption?.id === 'mobile') &&(!fundingSource)) {
      toast.error("Please select a funding source.", { toastId: "validation-toast2" });
      return;
    }

    if ((selectedOption?.id === 'cardplot' || selectedOption?.id === 'mobile') && !userRecipientInput?.trim()) {
      toast.error("Please enter recipient's username.", { toastId: "validation-toast4" });
      return;
    }

    if (selectedOption?.id === 'bank' && (!bankName || !accountNumber?.trim() || !inputtedAccountName?.trim())) {
      toast.error("Please select bank and enter account number/name.", { toastId: "validation-toast5" });
      return;
    }

    if (selectedOption?.id === 'mobile' && (!mobileMoney || !phone?.trim())) {
      toast.error("Please select mobile Money and enter phone number.", { toastId: "validation-toast6" });
      return;
    }

    const userCountryIso2 = userDetails?.country_code.toUpperCase()
    const userCurrency = userWallets.find((opt) => opt.country_iso2 === userCountryIso2); 

    let finalRecipientName = recipientUsername;
    let cardplotAcctNum
    if (selectedOption?.id === 'cardplot' || selectedOption?.id === 'mobile') {
      const result = await getRecipientCredentials(userRecipientInput);
      
      if (!result.success) return;
      finalRecipientName = result.data.name;
      cardplotAcctNum = result.data.acct_number;
    }
    let finalAccountName = accountName;
    if (selectedOption?.id === 'bank') {
      setAccountName(inputtedAccountName);
      finalAccountName = inputtedAccountName;      
    }
    let cardplotCurrencyId
    let currencyRefId
    if (selectedOption?.id === 'cardplot'){
      cardplotCurrencyId = userCurrency?.currencyId
      currencyRefId = userCurrency?.ref_id
    }
  
    const payload = {
      location: selectedTransferLocation,
      method: selectedOption?.title,
      fundingSource,
      transactionDescription,
      walletBalance: userCurrency?.amount,
      recipient: {
        username: selectedOption?.id === 'bank' ? finalAccountName : finalRecipientName,
        bank: bankName,
        acct_number: selectedOption?.id === 'cardplot' ? cardplotAcctNum : accountNumber,
        recipientCountry: selectedCountry,
        phone,
        mobileMoney,
        userRecipientInput,
        accountName,
        accountNumber,
        cardplotCurrencyId,
        currencyRefId
      },
    };
    
  
    // navigate("/user/withdraw_money/step2", { state: { payload: payload } });
  };

  const fetchBanks = async (countryCode) => {
    setLoadingBanks(true);
    setBanks([]); 
    try {
        const response = await fetchSupportedCountryBanks(countryCode);
        const banksName = response.data;            

        if (banksName.length > 0) {
            setBanks(banksName);
        } else {
            setBanks([]);
        }
    } catch (error) {
        // console.error("Error fetching banks:", error);
        setBanks([]);
    } finally {
        setLoadingBanks(false);
    }
  };

  useEffect(() => {
      if (selectedCountry) {
          fetchBanks(selectedCountry);
      }
  }, [selectedCountry]);
  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    const payload = location.state?.payload;
  
    if (payload) {
      setSelectedOption(
        sendOptions.find(option => option.title === payload.method) || null
      );
      setFundingSource(payload.fundingSource || '');
      setTransactionDescription(payload.transactionDescription || '');
  
      if (payload.recipient) {
        setRecipientUsername(payload.recipient.username || '');
        setUserRecipientInput(payload.recipient.userRecipientInput || '');
        setBankName(payload.recipient.bank || '');
        setAccountName(payload.recipient.accountName || '');
        setInputtedAccountName(payload.recipient.username || '');
        setAccountNumber(payload.recipient.accountNumber || '');
        setPhone(payload.recipient.phone || '');
        setMobileMoney(payload.recipient.mobileMoney || '');
      }
    }
  }, [location.state?.payload]);

  useEffect(() => {
    const transferLocation = location.state?.selectedTransferLocation;
    if (transferLocation) {
      setSelectedCountry(transferLocation.slug === 'local' ? userDetails?.country_code : 'ng');
    }
  }, [location.state?.selectedTransferLocation, userDetails]);  

  return (
    <section className='create__card__page send__money__page'>
      <section className='mt-3'>
        <CardsProgressSteps currentStep={1} stepLabels={["Details", "Amount", "Review/Withdraw", "Success"]} />
      </section>

      <div className='create_card_header d-flex align-items-center justify-content-center mt-5'>
        <img src={withdrawCardIcon} alt="icon" width="75px" height="75px" className='img-fluid' />
      </div>

      <div className='container mt-4'>
        <div className='create_card_header mt-5'>
            {selectedOption ? (<h4 className='mb-0 text-center'>Withdrawal Details</h4>):(<h4 className='mb-0 text-center'>Select Payment Option</h4>)}
            <hr />
        </div>


      <section className="send__money__form">
        <form onSubmit={handleContinue}>
          <div className="position-relative" ref={dropdownRef}>
            <div className="form-control d-flex justify-content-between align-items-center cursor-pointer"
              onClick={() => setShowDropdown(!showDropdown)}
              style={{ cursor: 'pointer' }}
            >
              {selectedOption ? selectedOption.title : 'Select Option'}
              <FaChevronDown />
            </div>

            {showDropdown && (
              <div className="border rounded mt-1 bg-white position-absolute w-100 shadow-sm mb-3" style={{ zIndex: 10 }}>
                {sendOptions.map((option) => (
                  <div
                    key={option.id}
                    className="p-2 border-bottom small"
                    onClick={() => {
                      setSelectedOption(option)
                      setShowDropdown(false)
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div className='p-2 rounded-circle bg-light'>{option.icon}</div>
                      <div>
                        <div className='fw-bold'>{option.title}</div>
                        <small className='text-muted'>{option.description}</small>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Conditionally Render Inputs Based on Selection */}
          <div className="mt-4">
            {selectedOption && (
              <>
                <div className="mb-4">
                    <label className="form-label">Amount to Withdraw <span className="text-danger">*</span></label>
                    <div>
                        <input type="number" className="form-control" placeholder="Enter amount" value={amount} onChange={handleAmountChange} min="1" />
                    </div>
                </div>
                <div className="mb-3">
                  <label className='form-label text-muted mb-0 ps-1'>Recipient Country</label>
                  <ReactFlagsSelect 
                    selected={selectedCountry} 
                    onSelect={setSelectedCountry} 
                    customLabels={countryNames}
                    countries={filteredCountryCodes}
                    disabled={isLocalTransfer}
                  />
                </div>
              </>
            )}
            {selectedOption?.id === 'cardplot' && (
              <>
                <div>
                  <label className='form-label mb-0 ps-1'>Enter Cardplot Details</label>
                  <div className="input-group mb-4">
                    <input type="text" className="form-control border-end-0" placeholder=" Account Name / Email *" 
                      value={userRecipientInput} onChange={(e) => setUserRecipientInput(e.target.value)}
                    />
                    <span className="input-group-text border-start-0"><RiUserReceivedLine size={24} color='#0A95FF' /></span>
                  </div>
                </div>
                <div>
                  <label className='form-label mb-0 ps-1'>Transaction Description <small className='text-muted'>(Optional)</small></label>
                  <input type="text" className="form-control mb-3" 
                    value={transactionDescription} onChange={(e) => setTransactionDescription(e.target.value)} 
                  />
                </div>
              </>
            )}

            {selectedOption?.id === 'bank' && (
              <>
                {/* <div className="mb-3">
                  <label className='form-label text-muted mb-0 ps-1'>Recipient Country</label>
                  <ReactFlagsSelect 
                    selected={selectedCountry} 
                    onSelect={setSelectedCountry} 
                    customLabels={countryNames}
                    countries={allowedCountryCodes}
                    disabled={isLocalTransfer}
                  />
                </div> */}
                <div>
                  <select className="form-select mb-3 mt-0 " aria-label="Default select example"
                    value={fundingSource?.id || ""} onChange={handleWalletSelectChange}
                  >
                    <option value=''>Select Source Wallet</option>
                    {loading ? (
                      <option>Loading...</option>
                    ) : (
                      userWallets.length > 0 ? (
                        userWallets.map((option, index) => (
                          <option key={index} value={option.id}>
                            {option.currency} ({option.currencyName})
                          </option>                              
                        ))
                      ) : (
                        <option>No wallet found</option>
                      )
                    )}
                  </select>
                </div>
                <div>
                  <label className='ms-2 text-muted mb-0'>Enter the recipient’s bank details for a secure transfer.</label>
                  {/* <label className='form-label mb-0 ps-1'>Select Mobile Money</label> */}
                  <select className="form-select mb-3 mt-0 " aria-label="Default select example"
                    onChange={(e) => setBankName(e.target.value)} value={bankName}
                  >
                    <option value=''>Select Bank</option>
                    {loadingBanks ? (
                        <option disabled selected>Loading...</option>
                    ) : banks.length > 0 ? (
                        banks.map((bank, index) => (
                            <option key={index} value={bank.name}>
                                {bank.name}
                            </option>
                        ))
                    ) : (
                        <option disabled selected>No bank available</option>
                    )}
                  </select>
                </div>
                <div>
                  <label className='form-label text-muted mb-0 ps-1'>Enter Account Number</label>
                  <input type="text" className="form-control mb-3" placeholder="" 
                    value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)}
                  />
                </div>
                <div>
                  {/* <label className='form-label mb-0 ps-1'>Bank Name</label> */}
                  <input type="text" className="form-control mb-3" placeholder="Account Name" 
                    value={inputtedAccountName} onChange={(e) => setInputtedAccountName(e.target.value)}
                  />
                </div>
                <div>
                  <label className='form-label mb-0 ps-1'>Transaction Description <small className='text-muted'>(Optional)</small></label>
                  <input type="text" className="form-control mb-3" 
                    value={transactionDescription} onChange={(e) => setTransactionDescription(e.target.value)}
                  />
                </div>
              </>
            )}

            {selectedOption?.id === 'mobile' && (
              <>
                {/* <div className="mb-3">
                  <label className='form-label text-muted mb-0 ps-1'>Recipient Country</label>
                  <ReactFlagsSelect 
                    selected={selectedCountry} 
                    onSelect={setSelectedCountry} 
                    customLabels={countryNames}
                    countries={allowedCountries}
                    disabled={isLocalTransfer}
                  />
                </div> */}
                <div>
                  {/* <label className='form-label mb-0 ps-1'>Select Source Wallet</label> */}
                  <select className="form-select mb-3 mt-0 " aria-label="Default select example"
                    value={fundingSource?.id || ""} onChange={handleWalletSelectChange}
                  >
                    <option value=''>Select Source Wallet</option>
                    {loading ? (
                      <option>Loading...</option>
                    ) : (
                      userWallets.length > 0 ? (
                        userWallets.map((option, index) => (
                          <option key={index} value={option.id}>
                            {option.currency} ({option.currencyName})
                          </option>                              
                        ))
                      ) : (
                        <option>No wallet found</option>
                      )
                    )}
                  </select>
                </div>
                <div>
                  <label className='form-label text-muted mb-0 ps-1'>Select an operator and enter recipient details.</label>
                  {/* <label className='form-label mb-0 ps-1'>Select Mobile Money</label> */}
                  <select className="form-select mb-3 mt-0 " aria-label="Default select example"
                    onChange={(e) => setMobileMoney(e.target.value)} value={mobileMoney}
                  >
                    <option value=''>Select Mobile Money</option>
                    {mobileMoneyOperators.map((card) => (
                        <option key={card.id} value={card.slug}>
                            {card.name}
                        </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className='form-label text-muted mb-0 ps-1'>Recipient Name</label>
                  <input type="text" className="form-control mb-3" placeholder="Recipient Name" 
                    value={userRecipientInput} onChange={(e) => setUserRecipientInput(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className='form-label text-muted mb-0 ps-1'>Recipient Phone Number</label>
                  <PhoneInput country={defaultCountry} value={phone} onChange={setPhone} onlyCountries={allowedCountries.map((country) => country.toLowerCase())} />
                </div>
                <div>
                  <label className='form-label mb-0 ps-1'>Transaction Description <small className='text-muted'>(Optional)</small></label>
                  <input type="text" className="form-control mb-3" 
                    value={transactionDescription} onChange={(e) => setTransactionDescription(e.target.value)}
                  />
                </div>
              </>
            )}
          </div>

          <button className='btn btn-primary mt-4 w-100' onClick={handleContinue} disabled={loading} >
            {loading ? (
                <div className="spinner-border spinner-border-sm text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            ) : 'Continue'} 
          </button>
        </form>
      </section>
      </div>
    </section>
  )
}

export default Step1WithdrawMoney;